/**
 * Returns the current restaurant session TOKEN (opaque random string from
 * restaurant_sessions table). Falls back to the user row id only for legacy
 * sessions stored before the token rollout.
 */
export function getRestaurantSessionId(): string | null {
  try {
    const stored = sessionStorage.getItem("kf-restaurant-session");
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return parsed?.token || parsed?.userId || null;
  } catch {
    return null;
  }
}

/** Returns the current tenant restaurant ID from the session, or null. */
export function getCurrentRestaurantId(): string | null {
  try {
    const stored = sessionStorage.getItem("kf-restaurant-session");
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return parsed?.restaurantId || null;
  } catch {
    return null;
  }
}
